module.exports = __webpack_public_path__ + "static/media/8.44772f79.jpg";